import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-booking-rate-calulation',
    templateUrl: './booking-rate-calulation.component.html',
    styleUrls: ['./booking-rate-calulation.component.css']
})
export class BookingRateCalulationComponent implements OnInit {
    @Input() payrollInvoice;
    @Input() index;
    @Input() isClient = false;
    @ViewChild('calculationFields') public form: NgForm;
    @Input() parentForm: NgForm;
    @Input() isReadOnly = false;
    interpRateOrdPlaceholder = '$0';
    prepRatePlaceholder = '$0';
    travelRatePlaceholder = '$0';
    totalPlaceholder = '$0';
    isNG = false;
    isWKN = false;

    private static convertToHours(time: string) {
        const matchedTime = time.match(/(\d+):(\d+)/);
        if (!matchedTime) {
            return 0;
        }
        return (+matchedTime[1]) + (+matchedTime[2] / 60);
    }
    constructor() { }

    ngOnInit() {
        if (Boolean(this.parentForm ) && Boolean(this.parentForm.form)) {
            let ctrlName = 'rateFields_' + (this.isClient ? 'client_' : 'interpreter_') + this.index;

            if (!this.parentForm.form.contains(ctrlName)) {
                this.parentForm.form.addControl(ctrlName, this.form.form);
            }
            this.parentForm.form.valueChanges.subscribe(valueObj => setTimeout(() => {
                this.calculateTotal();
            }, 0));

        }
        if (this.payrollInvoice) {
            this.isTimeNGOrWKN(this.payrollInvoice.interpreting_time_night, this.payrollInvoice.interpreting_time_weekend);
        }
    }

    private calculateTotal() {
        this.payrollInvoice.total = +this.payrollInvoice.transfers + +this.payrollInvoice.meals +
            +this.payrollInvoice.accommodations + +this.payrollInvoice.flights +
            (+this.payrollInvoice.interpreting_night_rate * BookingRateCalulationComponent.convertToHours(this.payrollInvoice.interpreting_time_night)) +
            (+this.payrollInvoice.interpreting_weekend_rate * BookingRateCalulationComponent.convertToHours(this.payrollInvoice.interpreting_time_weekend)) +
            (+this.payrollInvoice.interpreting_rate * BookingRateCalulationComponent.convertToHours(this.payrollInvoice.interpreting_time)) +
            (+this.payrollInvoice.preparation_rate * BookingRateCalulationComponent.convertToHours(this.payrollInvoice.preparation_time)) +
            (+this.payrollInvoice.travel_rate * BookingRateCalulationComponent.convertToHours(this.payrollInvoice.travel_time));
        this.payrollInvoice.total = parseFloat(this.payrollInvoice.total).toFixed(1);
    }

    isTimeNGOrWKN(timeNG: string, timeWKN: string) {
        let durationNG;
        let durationWKN;
        durationNG = timeNG.split(':');
        durationWKN = timeWKN.split(':');
        this.isNG = (Boolean(durationNG[0]) && durationNG[0] > 0) || (Boolean(durationNG[1]) && durationNG[1] > 0);
        this.isWKN = (Boolean(durationWKN[0]) && durationWKN[0] > 0) || (Boolean(durationWKN[1]) && durationWKN[1] > 0);
      }
}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-rate-calculation /booking-rate-calulation.component.ts